import React from 'react';
import { AlertTriangle } from 'lucide-react';

/**
 * Sticky urgency banner showing current combo seats sold / remaining.
 */
export function UrgencyBanner({ comboSales, urgencyConfig, comboPercent }) {
  const borderClass = urgencyConfig.level === 'critical'
    ? 'border-red-500/40'
    : urgencyConfig.level === 'sold-out'
      ? 'border-slate-700'
      : 'border-amber-500/20';

  return (
    <div data-testid="vagas-banner" className={`border-b ${borderClass} bg-[#080D1B]`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3">
        <div className="flex flex-col sm:flex-row sm:items-center gap-3 sm:gap-5">
          <div className="flex items-center gap-2 shrink-0">
            <AlertTriangle className={`w-4 h-4 ${urgencyConfig.text}`} />
            <span className={`text-xs font-extrabold uppercase tracking-widest ${urgencyConfig.text}`}>
              Vagas limitadas
            </span>
          </div>
          <div className="flex-1 min-w-0">
            <div className="flex items-center justify-between gap-3 mb-1.5">
              <span className="text-slate-300 text-xs sm:text-sm font-semibold truncate" data-testid="vagas-label">
                {urgencyConfig.label}
              </span>
              <span className="text-slate-400 text-xs font-mono shrink-0" data-testid="vagas-counter">
                <strong className="text-white">{comboSales.combo_count}</strong>/{comboSales.combo_total} vagas vendidas
              </span>
            </div>
            <div className="relative h-1.5 bg-slate-800 rounded-full overflow-hidden">
              <div
                className={`h-full bg-gradient-to-r ${urgencyConfig.bar} transition-all duration-700 ease-out`}
                style={{ width: `${Math.max(2, comboPercent)}%` }}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
